/**
 * @desc 订单添加备注
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.SystemOrderRemarkRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/addRemark`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
